export default __webpack_public_path__ + "static/media/service3.3e6b87cd.jpg";